var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.94786 18.0001L4 22.0001V6.00006C4 5.73484 4.10536 5.48049 4.29289 5.29295C4.48043 5.10542 4.73478 5.00006 5 5.00006H21C21.2652 5.00006 21.5196 5.10542 21.7071 5.29295C21.8946 5.48049 22 5.73484 22 6.00006V17.0001C22 17.2653 21.8946 17.5196 21.7071 17.7072C21.5196 17.8947 21.2652 18.0001 21 18.0001H8.94786Z",
    stroke: "var(--color-icon-chats-stroke, black)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.0001V23.0001C10 23.2653 10.1054 23.5196 10.2929 23.7072C10.4804 23.8947 10.7348 24.0001 11 24.0001H23.0521L28 28.0001V12.0001C28 11.7348 27.8946 11.4805 27.7071 11.293C27.5196 11.1054 27.2652 11.0001 27 11.0001H22",
    stroke: "var(--color-icon-chats-stroke, black)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChats);
export default __webpack_public_path__ + "static/media/Chats.6782e5cb727f3eb691f2edb607197dda.svg";
export { ForwardRef as ReactComponent };